<div class="tml-tpl-input tam-contact-control" [style.width.px]="childConfig.css.width"
    attr.tid="{{config.controlName}}">
    <kendo-datepicker calendarType="classic" [(value)]="value" (valueChange)="textOnChange($event)"
        [rangeValidation]="false" [min]="min" [style.width.px]="childConfig.css.width" [max]="max" [disabled]="readOnly"
        [popupSettings]="{appendTo: 'component'}">
    </kendo-datepicker>
    <label [hidden]="!hintContent" class="item-label-error">
        {{hintContent}}
    </label>
</div>